<template>
  <!-- <v-container class="fill-height">
    <Plans></Plans>
  </v-container>-->
  <v-container class="fill-height">
    <v-row no-gutters align="center" justify="center" class="white--text">
      <v-col cols="12" sm="12" md="12" xl="12">
        <Plans />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Plans from "@/components/products/Prices.vue";

export default {
  name: "Footer",
  components: {
    Plans
  }
};
</script>